import { t } from "@/i18n-js/instance";
import type { EditorFieldProps } from "../DefaultEditorFields";
import { DefaultEditorFields } from "../DefaultEditorFields";
import { DefaultEditorV2Collapsable } from "./DefaultEditorV2Collapsable";

export interface DefaultEditorV2FieldsListProps {
  fields: EditorFieldProps[];
  title?: string;
  titleI18n?: string;
}

export const DefaultEditorV2FieldsList = ({
  title,
  titleI18n,
  fields,
}: DefaultEditorV2FieldsListProps) => {
  const displayTitle = titleI18n ? t(titleI18n) : title;

  return (
    <DefaultEditorV2Collapsable title={displayTitle}>
      <div className="flex flex-col gap-4 px-6 py-4">
        {fields.map(({ name, propMeta }) => (
          <DefaultEditorFields key={name} name={name} propMeta={propMeta} />
        ))}
      </div>
    </DefaultEditorV2Collapsable>
  );
};
